module.exports = __webpack_public_path__ + "tc.3886447a.svg";